module.exports = __webpack_public_path__ + "static/media/item-7.6a9cad58.jpeg";